export type DebouncedFunction<T extends (...args: any[]) => any> = ((
    ...args: Parameters<T>
) => void) & {
    cancel: () => void;
};

export function debounce<T extends (...args: any[]) => any>(
    func: T,
    wait: number,
): DebouncedFunction<T> {
    let timeout: ReturnType<typeof setTimeout> | null;

    const debounced = function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        const context = this;
        const later = () => {
            timeout = null;
            func.apply(context, args);
        };

        if (timeout !== null) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(later, wait);
    } as DebouncedFunction<T>;

    debounced.cancel = function () {
        if (timeout !== null) {
            clearTimeout(timeout);
            timeout = null;
        }
    };

    return debounced;
}
